// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-referencebox]", {
    zoomEffect: true,
  });

  var swiperPreogressBar = new Swiper(".swiper-with-porogressbar", {
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,

    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    on: {
      init: function () {
        updateCounter(this);
      },
      slideChange: function () {
        updateCounter(this);
      },
    },
  });

  function updateCounter(swiper) {
    const total = swiper.slides.length;
    const current = swiper.realIndex + 1;

    document.querySelector(".swiper-pagination-counter .current").textContent =
      format(current);
    document.querySelector(".swiper-pagination-counter .total").textContent =
      format(total);
  }

  function format(num) {
    return num < 10 ? "0" + num : num;
  }

  var swiperMultipleLinePartners = new Swiper(".multiple-line-partners", {
    loop: true,

    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    // centeredSlides: true,

    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
      // type: 'fraction',
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var subSwiper = new Swiper(".multiple-line-partners", {
    loop: true,
    // direction: "vertical",
    pagination: {
      el: ".swiper-pagination-counter",
      type: "fraction",
    },
  });
  swiperMultipleLinePartners.controller.control = subSwiper;
  if (window.innerWidth > 991) {
    var swiperReferences = new Swiper(".swiper-references", {
      loop: true,
      slidesPerView: 5,
      centeredSlides: true,
      spaceBetween: 61,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});
